import React, { useEffect, useState } from "react";
import {MatchDateInfo, MemoGameStatus} from './GameStatus';
import {ChessMarkets, Markets} from './Markets';
import {MoreLessToggleIcon} from '../../../custom/MoreLessToggleIcon';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {SHOW_WIDGET} from '../../../../store/spirs/actions';
import {FixtureElement, GroupedMarketElements, TreeSettings} from "../../../../models/api/codegen/code";
import {PeriodGroupedMarkets} from "../../../../markets/RequiredDisplayMarketTitles";
import {
    MarketGroup,
    MarketMenuGroup, marketToRows,
    PeriodMarketGroup
} from "../../../../markets/marketMapping";
import {LiveOrLineType, StoreType} from "../../../../store/spirs/types";
import {ReactComponent as ProceedChevronIcon} from '../../../VerticalMenu/icons/proceed_chevron.svg';
import {Visible} from "../../../../utils/Visible";
import {useTranslation} from "react-i18next";
import {useFavorites} from "../../../../utils/FavoritesUtils";
import LogoFavorite from '../../icons/specialFavoriteLogo';
import {PeriodMarket} from "./PeriodMarket";
import {useNavigate} from "react-router-dom";
import clsx from "clsx";
import {useElementInScreen} from "../../../../hooks/useElementInScreen";
import { Popup } from "../../../Favorites/FavouritesPopup";
import { ReactComponent as FieldIcon } from '../../../../assets/svg/field_icon.svg';
import { useTestOverlay } from '../../../coupons/TestOverlayContext';



const ToggleFixturesButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #171A1E;
    border-radius: 0 8px 8px 0;
`;
ToggleFixturesButton.displayName = 'ToggleFixturesButton';

const EmptyToggle = styled.div<{ isLast: boolean }>`
    width: 100%;
    background-color: #171A1E;
    height: 100%;
    border-radius: ${props => props.isLast ? '0 0 8px 0' : '0 0 0 0'};
`;
EmptyToggle.displayName = 'EmptyToggle';

const NextButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #121518;
    height: 100%;
`;
NextButton.displayName = 'NextButton';

interface FixtureProps {
    callback?: any;
    fixture: FixtureElement;
    prefixPath: string;
    marketGroupsToDisplay: MarketGroup[];
    mode: LiveOrLineType;
    color: string;
    mobileMarketGroup: MarketGroup;
    isChessLive: boolean
    settings: TreeSettings;
    markets: Array<GroupedMarketElements>;
    alreadyStarted: boolean;
}
// может пригодится еще
// export const Fixture = (props: FixtureProps) => {
//     const {containerRef, isVisible} = useElementInScreen({
//         /* Optional options */
//         threshold: 0,
//     });
//
//     return (
//         <div ref={containerRef}>
//             {(isVisible) ? (
//                 <FixtureRow {...props}/>
//             ) : (
//                 <FixturePlaceholder/>
//             )}
//         </div>
//     )
// }
//
// const FixturePlaceholder = React.memo(() => {
//     return (
//         <div className="w-full h-[50px] mt-[1px] rounded-lg bg-[linear-gradient(to_right,_#171A1E_8%,_#1e2326_18%,_#171A1E_33%)] bg-[length:200%_50px]">
//
//         </div>
//     )
// }, (prev, next) => true);

export const Fixture: React.FC<FixtureProps> = (props) => {
    const {t} = useTranslation();
    let navigate = useNavigate();
    const isDisplayPeriodMarkets = useSelector((state: StoreType) => state.appSettings.displayPeriodMarkets);
    const {fixture, markets, settings, prefixPath, marketGroupsToDisplay, callback, mode, color, mobileMarketGroup, isChessLive} = props;
    const [showPeriodMarkets, togglePeriodMarkets] = useState(isDisplayPeriodMarkets);
    const dispatch = useDispatch();
    const { showOverlay, isConnecting, countdown } = useTestOverlay();
    const hasOverlay = (showOverlay || isConnecting) && !!countdown;

    const onGameStatusClick = (withWidget: boolean): void => {
        if (!fixture.a) {
            return;
        }
        dispatch(SHOW_WIDGET(withWidget))
        redirectToFixture();
    };

    const onGameStatusClickMobile = (withWidget: boolean): void => {
        if (!fixture.a) {
            return;
        }
        dispatch(SHOW_WIDGET(withWidget))
        return navigate(`${prefixPath}event/mobile/${fixture.fi}`)
    };

    const redirectToFixture = () => navigate(`${prefixPath}event/${fixture.fi}`);
    const handleSelectMobileFixture = () => redirectToFixture();
    React.useEffect(() => {
        togglePeriodMarkets(isDisplayPeriodMarkets);
    }, [isDisplayPeriodMarkets]);

    const onToggleFixturesButtonClick = () => togglePeriodMarkets(prevState => !prevState);

    const groups = React.useMemo(() => {
        return marketGroupsToDisplay.map(main => ({
            groups: (MarketMenuGroup.find(m => m.name === main) || {groups: [] as MarketGroup[]}).groups
        }));
    }, [marketGroupsToDisplay])

    const groupedMarkets: PeriodGroupedMarkets[] = React.useMemo(() => {
        return PeriodMarketGroup.map(period => ({
            name: t(period.name.toLowerCase().replace("_", "")),
            groups: groups.map(periodGroup => periodGroup.groups.filter(p => period.groups.indexOf(p) > -1)).map(gs => ({
                group: gs[0] as MarketGroup,
                groupedMarkets: gs.length > 0 ? markets.find(m => m.g === gs[0]) : null
            })),
            number: period.index
        }));
    }, [groups, markets])

    const periods = React.useMemo(() => {
        return groupedMarkets.filter((g, i) => i > 0 && g.groups.filter(gr => gr.groupedMarkets).length > 0);
    }, [groupedMarkets])

    const getHomeScore = (i: number) => {
        if (fixture.ms && fixture.ms.periodScores) {
            const period = fixture.ms.periodScores.find(period => period.periodNumber === i);
            if (!period || !period.homeScore || !period.awayScore) {
                return '';
            }
            return period.homeScore + ':' + period.awayScore
        }
        return '';
    };

    const favorite: boolean = React.useMemo(() => {
        return settings.f.indexOf(fixture.fi) > -1;
    }, [fixture.fi, settings.f])

    const suspended: boolean = React.useMemo(() => {
        let checkProducer = false;
        if (fixture.pr === "LIVE") {
            checkProducer = settings.l;
        } else if (fixture.pr === 'PREMATCH') {
            checkProducer = settings.p;
        }
        return !checkProducer || settings.s || fixture.fsd || props.alreadyStarted;
    }, [fixture.pr, settings.l, settings.p, settings.s, fixture.fsd, props.alreadyStarted])

    return (<div id={`fixture-${fixture.fi}`}>
        <MarketRow type={'main'}
                   isChessLive={isChessLive}
                   favorite={<MemoFavorite fixtureId={fixture.fi}
                                       favorite={favorite}
                                       color={color}/>}
                   info={<MemoGameStatus color={color}
                                     fixture={fixture}
                                     onClick={onGameStatusClick}
                                     onClickMobile={onGameStatusClickMobile}
                                     callback={callback}
                                     mode={mode}
                                     isChessLive={isChessLive}/>}
                   markets={<Markets fixtureId={fixture.fi}
                                     groupedMarkets={groupedMarkets[0]}
                                     marketGroupsToDisplay={marketGroupsToDisplay}
                                     status={fixture.s}
                                     mobileMarketGroup={mobileMarketGroup}
                                     competitionName={fixture.cn}
                                     suspended={suspended}
                                     hasOverlay={hasOverlay}
                   />}
                   chessMarkets={isChessLive ? <ChessMarkets fixture={fixture} hasOverlay={hasOverlay}/> : <></>}
                   toggle={isChessLive ?
                       <ToggleFixturesButton/> : (
                           <ToggleFixturesButton onClick={onToggleFixturesButtonClick}

                           >
                               <MoreLessToggleIcon isOpen={showPeriodMarkets}/>
                           </ToggleFixturesButton>
                       )}
                   next={<NextButton onClick={handleSelectMobileFixture}>
                       <ProceedChevronIcon/>
                   </NextButton>}
                   matchDate={<MatchDateInfo
                       color={color}
                       fixture={fixture}
                       onClick={onGameStatusClick}
                       onClickMobile={onGameStatusClickMobile}
                       callback={callback}
                       mode={mode}
                       isChessLive={isChessLive}
                   />}
                   mobileMarketGroup={mobileMarketGroup}
                   fixtureId={fixture.fi}
                   color={color}
        />
        <div className="max-mobile:hidden">
            <Visible value={showPeriodMarkets}>
                {periods.map((period, i) => (
                    <MarketRow type={'period'}
                               key={i}
                               isChessLive={isChessLive}
                               favorite={<EmptyFavorite isLast={i === periods.length - 1}/>}
                               info={<PeriodInfo periodName={period.name} />}
                               markets={<PeriodMarket fixtureId={fixture.fi}
                                                      isLast={i === periods.length - 1}
                                                      marketGroupsToDisplay={marketGroupsToDisplay}
                                                      mobileMarketGroup={mobileMarketGroup}
                                                      competitionName={fixture.cn}
                                                      status={fixture.s}
                                                      score={getHomeScore(period.number)}
                                                      period={period}
                                                      suspended={suspended}
                                                      hasOverlay={hasOverlay}/>}
                               matchDate={<div/>}
                               mobileMarketGroup={mobileMarketGroup}
                               toggle={<EmptyToggle isLast={i === periods.length -1}/>}

                    />
                ))}
            </Visible>
        </div>
    </div>);
};

interface MarketRowProps {
    isChessLive: boolean
    favorite: React.ReactElement
    info: React.ReactElement
    matchDate: React.ReactElement
    markets?: React.ReactElement
    chessMarkets?: React.ReactElement
    toggle?: React.ReactElement
    next?: React.ReactElement
    mobileMarketGroup: MarketGroup,
    fixtureId?: number;
    color?: string;
    type: 'main' | 'period'
}

const MarketRow: React.FC<MarketRowProps> = (props) => {
    const {isChessLive, favorite, info, markets, chessMarkets, toggle, next, matchDate, mobileMarketGroup, fixtureId, color, type} = props;
    const mobileGroup = marketToRows[mobileMarketGroup];
    const [hasToggle, setHasToggle] = useState<boolean>(!!toggle);
    const {t} = useTranslation();

    useEffect(() => {
        if (
            markets?.props?.marketGroupsToDisplay &&
            markets?.props?.groupedMarkets
        ) {
            // За аналог/пример взят код из Markets.tsx::Markets в области возврата компонента
            // Данные вычисления определяют есть ли у текущего события варианты исходов
            const availableMarketsInMarketRow: any[] = markets?.props.marketGroupsToDisplay
                .map((marketGroup: MarketGroup) => {
                    const innerMapMarkets = markets?.props.groupedMarkets.groups.filter(
                        (g: any) => g.group === marketGroup
                    );

                    return innerMapMarkets.length > 0
                        ? innerMapMarkets[0].groupedMarkets
                            ? innerMapMarkets[0].groupedMarkets.m[0]
                            : null
                        : null;
                })
                .filter((st: any) => st !== null);

            // Установка флага на отображение стрелки раскрытия события
            setHasToggle(availableMarketsInMarketRow.length > 0);
        }
    }, [markets]);

    return (
        <>
            {type === 'main' && (
                <div className="flex tablet:hidden bg-[#1B1E23] justify-between pl-[10px] py-[5px]">
                    <div className="flex justify-between items-center w-[147px]">
                        <div>{toggle}</div>
                        <div className="flex flex-col items-center">
                            <FieldIcon />
                        </div>
                        <div>{favorite}</div>
                    </div>
                    <div className="flex">
                        {mobileGroup?.map((item: string) => (
                            <div
                                key={item}
                                className={`flex-shrink-0 ${
                                    mobileGroup?.length > 3
                                        ? 'w-[40px]'
                                        : 'w-[48px]'
                                } text-center text-[#6B7075] font-normal mx-[1px]`}
                            >
                                {t(item)}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <div
                className={` bg-[#1B1E23] pl-[10px] pr-[2px] tablet:pl-[15px] tablet:pr-[15px] py-[5px] text-[12px] mb-[1px] flex items-center justify-between `}
            >
                <div className="flex items-center">
                    <div className="flex flex-col items-center">
                        <div className="hidden tablet:flex justify-center items-center">
                            {favorite}
                        </div>
                        <div
                            className="hidden tablet:block text-xs mt-1"
                            style={{ color: color }}
                        >
                            {fixtureId}
                        </div>
                    </div>
                    <div
                        className={`${
                            !hasToggle ? 'invisible' : ''
                        } max-tablet:hidden`}
                    >
                        {toggle}
                    </div>
                    {info}
                </div>
                <div className="flex gap-[7px] items-center">
                    <div className="hidden tablet:flex">{matchDate}</div>
                    {/*for desktop*/}
                    {isChessLive ? chessMarkets : markets}
                </div>
            </div>
            {/*<div className="tablet:hidden">*/}
            {/*    <div className="mb-5">*/}
            {/*        {isChessLive ? (*/}
            {/*            <div className="grid grid-cols-5">*/}
            {/*                {chessMarkets}*/}
            {/*            </div>*/}
            {/*        ) : markets}*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    );
};

type FavoriteProps = {
    fixtureId: number
    favorite?: boolean
    color: string
}

const Favorite: React.FC<FavoriteProps> = ({fixtureId, favorite, color}) => {
    const favoritesAmount = useSelector((state: StoreType) => state.spirs.favoritesCount);
    const {isFavorite, onChange} = useFavorites(fixtureId, useDispatch(), favorite);
    const [isOpenPopup, setIsOpenPopup] = useState<boolean>(false);

    const handleFavourites = () => {
        if (!isFavorite && favoritesAmount > 49) {
            openPopup();
        } else {
            onChange();
        }
    }

    const openPopup = () => setIsOpenPopup(true);
    const closePopup = () => setIsOpenPopup(false);

    return (<div className={`flex justify-center items-center h-full bg-[#171A1E] max-tablet:rounded-tl-lg max-tablet:rounded-bl-none`}>
        <Popup isOpen={isOpenPopup} onClose={closePopup} fixtureId={fixtureId} favorite={favorite} />
        <div onClick={handleFavourites}>
            <LogoFavorite checked={isFavorite} size='24'/>
        </div>
    </div>)
};

const MemoFavorite = React.memo(Favorite, (p, n) => p.favorite === n.favorite);

const PeriodInfo: React.FC<{ periodName: string }> = ({periodName}) => {
    return (<div className="flex justify-between items-center h-full bg-[#171A1E] text-[#999A9B] text-[14px]">
        <div className="pl-[36px]">{periodName}</div>
    </div>)
};

const EmptyFavorite: React.FC<{ isLast: boolean }> = ({isLast}) => {
    return (<div className="h-full grid grid-cols-[10px] justify-end">
        <div className={clsx("bg-[#171A1E]", isLast ? "rounded-br-[8px]" : "rounded-br-0")}/>
    </div>)
};
